<nice-vertical-navigation
    class="print:hidden"
    [class.hidden]="shouldHideNav"
    [name]="'mainNavigation'"
    [appearance]="appearance"
    [translationContext]="translationContext"
    [opened]="!isSmallScreen"
    [mode]="isSmallScreen ? 'over' : 'side'"
>
    <ng-container niceVerticalNavigationHeader>
        <div
            *ngIf="organisation$ | async as org"
            class="logo-container flex h-full w-fit select-none flex-col items-center justify-center"
        >
            <img #image class="long-logo max-h-12 w-fit" [src]="org?.logo" />
            <div class="flex w-full items-end justify-end gap-1.5 pr-1.5">
                <span class="long-logo text-xs leading-none">{{ "general.powered_by" | translate }}</span>
                <img class="long-logo w-15" src="./assets/images/logo-municipal.svg" />
            </div>
        </div>
    </ng-container>

    <!-- Custom padding -->
    <ng-container niceVerticalNavigationContentHeader>
        @let account = currentAccount();
        @if (account && (account.role === "organisation_admin" || account.role === "organisation_super_admin")) {
            <div class="h-4"></div>
        }
    </ng-container>

    <ng-container niceVerticalNavigationFooter>
        <div class="footer w-full p-8">
            <nerri-user-menu></nerri-user-menu>
        </div>
    </ng-container>
</nice-vertical-navigation>
